import gql from "graphql-tag";

export default gql`
  mutation QueryEmailSignup($email: String!, $password: String!) {
    signupEmailPassword(email: $email, password: $password) {
      token
    }
  }
`;
